import Swiper from "swiper";

class AdmissionDeadlinesSlider {
    constructor(el) {
        this.el = el;
        this.activeSlide = this.el.getAttribute("data-active-slide");
        this.enableSlider();
    }

    enableSlider() {
        new Swiper(this.el, {
            slidesPerView: "auto",
            slidesOffsetAfter: 15,
            watchSlidesVisibility: true,
            initialSlide: this.activeSlide,
            observer: true,
            observeParents: true,
            slideToClickedSlide: true,
            longSwipesRatio: 0.3,
            touchRatio:1,
            followFinger: false,
        });
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-slider-docs")
        .forEach(slider => new AdmissionDeadlinesSlider(slider));
});